import { Route } from '@angular/router';

export const rootRoute: Route = {
  path: '',
  pathMatch: 'full',
  redirectTo: '/home',
};
